import React from "react";
import { useTranslation } from "../../../contexts/TranslationContext";
import { Form } from "../../../types";

interface FormConfigurationProps {
  form: Form;
}

const FormConfiguration: React.FC<FormConfigurationProps> = ({ form }) => {
  const { t } = useTranslation();

  return (
    <div className="bg-white shadow rounded-lg">
      <div className="px-4 py-5 sm:p-6">
        <h3 className="text-lg font-medium text-gray-900 mb-4">
          {t("forms.detail.configuration.title")}
        </h3>
        <dl className="space-y-3">
          <div>
            <dt className="text-sm font-medium text-gray-500">
              {t("forms.detail.configuration.customFields")}
            </dt>
            <dd className="mt-1 text-sm text-gray-900">
              {form.custom_fields && form.custom_fields.length > 0 ? (
                <div className="space-y-2">
                  {form.custom_fields.map((field, index) => (
                    <div
                      key={index}
                      className="border border-gray-200 rounded-lg p-3"
                    >
                      <div className="flex items-center justify-between">
                        <div>
                          <p className="text-sm font-medium text-gray-900">
                            {field.label}
                          </p>
                          <p className="text-xs text-gray-500 font-mono">
                            {field.name}
                            {field.required && (
                              <span className="ml-2 text-red-500">*</span>
                            )}
                          </p>
                          {field.pipedrive_deal_field_id && (
                            <p className="text-xs text-gray-500">
                              Pipedrive Deal Field ID:{" "}
                              {field.pipedrive_deal_field_id}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <span className="text-gray-500 italic">
                  {t("forms.detail.configuration.noCustomFields")}
                </span>
              )}
            </dd>
          </div>
          {form.pipedrive_product_id && (
            <div>
              <dt className="text-sm font-medium text-gray-500">
                {t("forms.detail.configuration.pipedriveProductId")}
              </dt>
              <dd className="mt-1 text-sm text-gray-900">
                <a
                  href={form.pipedrive_product_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-1"
                >
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"
                      stroke="#26292c"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"
                      stroke="#26292c"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  {form.pipedrive_product_id}
                </a>
              </dd>
            </div>
          )}
        </dl>
      </div>
    </div>
  );
};

export default FormConfiguration;
